import React from 'react';
import { OV_STRINGS } from '../../constants/strings';
import icons from '../../../../assets/images/icons';
import styles from './ExitConfirmModal.module.scss';

function ExitConfirmModal({ onConfirm, onBack }) {
  return (
    <>
      <div className={styles.dim} />
      <div className={styles.pos}>
        <div className={styles.modal}>

          <div className={styles.thumbBg}>
            <img src={icons.ov.exitConfirm} alt="" className={styles.thumbImg} />
          </div>


          <div className={styles.content}>
            <h2 className={styles.title}>{OV_STRINGS.EXIT_TITLE}</h2>
            <p className={styles.desc}>{OV_STRINGS.EXIT_DESC}</p>
          </div>


          <div className={styles.actionArea}>
            <button type="button" className={styles.deleteBtn} onClick={onConfirm}>
              {OV_STRINGS.EXIT_CONFIRM}
            </button>
            <button type="button" className={styles.backBtn} onClick={onBack}>
              {OV_STRINGS.EXIT_BACK}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ExitConfirmModal;
